import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { LinkTabNavHorizontal } from '../../components';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { FormattedMessage } from '../../util/reactIntl';

import css from './UserNav.module.css';

const UserNav = props => {
  const { className, rootClassName, currentPage, isHomePage } = props;
  const classes = classNames(rootClassName || css.root, className);

  const tabs = [
    {
      text: <FormattedMessage id="UserNav.yourListings" />,
      selected: currentPage === 'ManageListingsPage',
      linkProps: {
        name: 'ManageListingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  return (
    <div>
      <LinkTabNavHorizontal
        className={classes}
        tabRootClassName={css.tab}
        tabs={tabs}
        skin="dark"
      />
    </div>
  );
};

UserNav.defaultProps = {
  className: null,
  rootClassName: null,
  isHomePage: true,
};

const { string } = PropTypes;

UserNav.propTypes = {
  className: string,
  rootClassName: string,
  currentPage: string.isRequired,
};

export default UserNav;
